export default (() => {
  return {
    name: "none"
  };
});